
import React from 'react';
const Assetreport = () =>{
    return (
        <div>Asset Report</div>
      )
}

export default Assetreport;